var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCFckkkew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1342_6131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#686868"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0001 33.9848C26.9917 34.537 27.4325 34.9915 27.9847 34.9999C28.537 35.0083 28.9915 34.5675 28.9999 34.0153L27.0001 33.9848ZM28.8972 21.5439C28.5127 21.1474 27.8796 21.1378 27.4831 21.5223L21.0229 27.7885C20.6264 28.173 20.6168 28.8061 21.0013 29.2025C21.3858 29.5989 22.0189 29.6086 22.4153 29.2241L28.1578 23.6542L33.7277 29.3966C34.1123 29.7931 34.7453 29.8027 35.1418 29.4182C35.5382 29.0337 35.5479 28.4006 35.1633 28.0042L28.8972 21.5439ZM28.9999 34.0153L29.1793 22.2554L27.1795 22.2249L27.0001 33.9848L28.9999 34.0153Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9883 18.997L40.9988 37.0002C40.9992 37.5482 40.5558 37.994 39.9991 37.9941L16.0002 37.9995C15.4479 37.9997 15 37.5519 15 36.9995V19C15 18.4477 15.4477 18 16 18H39.9883C40.5419 18 40.9879 18.4465 40.9883 18.997Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1342_6131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCFckkkew);
export default __webpack_public_path__ + "static/media/cFckkkew.1be04d0c406b0b36dd382b4d66e3e26c.svg";
export { ForwardRef as ReactComponent };